/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles/";
import { debounce } from "lodash";
import PropTypes from "prop-types";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { MdDragIndicator, MdViewColumn } from "react-icons/md";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import ImagemDefault from "../../assets/images/map-default.svg";
import { AdminTitle } from "../../pages/admin/components/AdminTitle";
import HeaderButton from "../../pages/admin/components/headerButton";
import RefreshButton from "../../pages/admin/components/RefreshButton";
import Loading from "../../pages/home/components/Loading";
import InputForm from "../../components/InputForm";
import { Portlet, PortletBody } from "../../partials/content/Portlet";
import globalColors from "../../../_metronic/_assets/sass/custom/globalColors.scss";
import { AppAPIService } from "../../services/AppAPIService";
import {
  IconButton,
  Grid,
  SvgIcon,
  InputAdornment,
  Container,
} from "@material-ui/core";
import { ReactComponent as LastPageIcon } from "../../assets/custom-icons/cheveron-last-right.svg";
import { ReactComponent as FirstPageIcon } from "../../assets/custom-icons/cheveron-first-left.svg";
import { ReactComponent as NextPageIcon } from "../../assets/custom-icons/cheveron-right.svg";
import { ReactComponent as PreviousPageIcon } from "../../assets/custom-icons/cheveron-left.svg";
import { ReactComponent as SearchIcon } from "../../assets/custom-icons/search-icon.svg";
import {
  ImageContainer,
  OpenContainerButton,
  StyledTableCell,
  StyledTableContent,
  StyledTableRow,
} from "./styles";
import "./styles.css";

const EnhancedTableHead = (props) => {
  const { headRows, onSort, order, orderBy } = props;

  const generateRow = (headRows) => (
    <TableRow>
      {(headRows || []).map((row, i) => (
        <TableCell
          key={row.column || i}
          align={row.align ? row.align : "left"}
          padding={row.disablePadding ? "none" : "default"}
          size={row.size || null}
          width={row.width || undefined}
          variant="head"
          style={{
            textAlign: row.align ? row.align : "left",
            backgroundColor: globalColors.secondaryColor3,
            fontWeight: "600",
          }}
          component={StyledTableCell}
          data-grid-sort-managed="true"
          onClick={row.sortable === false ? undefined : () => onSort(row)}
          aria-sort={
            orderBy === (row.sortField || row.column)
              ? order === "asc"
                ? "ascending"
                : "descending"
              : undefined
          }
        >
          <span
            style={{
              alignItems: "center",
              cursor: row.sortable === false ? "default" : "pointer",
              display: "inline-flex",
              gap: "6px",
              userSelect: "none",
            }}
          >
            {row.label}
            {row.sortable !== false && (
              <span aria-hidden="true">
                {orderBy === (row.sortField || row.column)
                  ? order === "asc"
                    ? "▲"
                    : "▼"
                  : "⇅"}
              </span>
            )}
          </span>
        </TableCell>
      ))}
    </TableRow>
  );

  return (
    <TableHead
      style={{
        backgroundColor: globalColors.secondaryColor3,
      }}
    >
      {Array.isArray(headRows[0]) &&
        headRows.map((row) => {
          return generateRow(row);
        })}
      {!Array.isArray(headRows[0]) && generateRow(headRows)}
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  rowCount: PropTypes.number.isRequired,
  headRows: PropTypes.array.isRequired,
};

const api = AppAPIService.getInstance();

const normalizePaginatedResponse = (response, params) => {
  const payload =
    response?.data && !Array.isArray(response.data) && response.data.data
      ? response.data
      : response;

  const rows = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
    ? payload
    : [];

  const meta = payload?.meta || response?.meta || {
    currentPage: params.page,
    lastPage: 1,
    total: rows.length,
  };

  return {
    rows,
    meta: {
      currentPage: Number(meta.currentPage || params.page || 1),
      lastPage: Number(meta.lastPage || 1),
      total: Number(meta.total || rows.length || 0),
    },
  };
};

const getSortableValue = (row, field) => {
  const value = String(field || "")
    .split(".")
    .filter(Boolean)
    .reduce((current, key) => current?.[key], row);

  if (value && typeof value === "object") {
    return value.name || value.action || value.status || value.username || "";
  }
  return value ?? "";
};

const sortRows = (rows, field, direction) =>
  [...rows].sort((first, second) => {
    const firstValue = getSortableValue(first, field);
    const secondValue = getSortableValue(second, field);
    const comparison = String(firstValue).localeCompare(String(secondValue), "pt-BR", {
      numeric: true,
      sensitivity: "base",
    });
    return direction === "desc" ? -comparison : comparison;
  });

const Datatable = (props) => {
  const { widthTable } = props;
  const useStyles = makeStyles(() => {
    return {
      root: {
        //tabela e pesquisa
        maxHeight: "fit-content",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        minHeight: props.removeMinHeight ? "fit-content" : "75vh",
        borderRadius: "4px",
      },
      paper: {
        width: "100%",
        flex: "1",
      },
      table: {
        minWidth: widthTable ? widthTable : 400,
        overflowX: "scroll",
        background: `${globalColors.backgroundColor6}40`,
      },
      tableWrapper: {
        overflow: "hidden !important",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        height: "100%",
        overflowX: "auto",
        borderRadius: "4px",
        boxShadow: props.removeShadow
          ? "none"
          : "0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2)",
        border: "none",
      },
      tableContainer: {
        padding: props.removePadding ? 0 : "0 16px 0px 16px",
        marginTop: "5px",
      },
      search: {
        padding: props.removePadding ? "16px 0" : 16,
      },
      input: {
        border: `.5px solid ${globalColors.backgroundColor2}`,
        paddingRight: "10px",
        borderRadius: "4px",
        height: "48px",
        marginRight: "10px",
      },
      rows: {
        padding: "0 !important",
        margin: "0 !important",
      },
      addBtn: {
        padding: "16px 0",
        marginLeft: "16px",
      },
    };
  });

  const classes = useStyles();
  const currentState = loadPaginationState();
  const defaultSortColumn = props.headRows
    .flatMap((row) => (Array.isArray(row) ? row : [row]))
    .find((column) => column.sortable !== false);

  const [rows, setRows] = useState(props.rows);

  const [order, setOrder] = useState(currentState.order || "desc");
  const [orderBy, setOrderBy] = useState(
    currentState.orderBy ||
      props.orderBy ||
      defaultSortColumn?.sortField ||
      defaultSortColumn?.column ||
      "Id"
  );
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(
    props.rowsPerPage || currentState.perPage || 10
  );
  const [count, setCount] = useState(rows?.length);
  const [inputSearch, setInputSearch] = useState(props.search || "");
  const [optionFilter, setOptionFilter] = useState("");
  const [isLoading, setIsLoading] = useState("");
  const [isLoadingExport, setIsLoadingExport] = useState("");
  const [reload, setReload] = useState(false);
  const pageCurrentState = currentState.page;
  const [isOpen, setIsOpen] = useState(false);
  const [isColumnMenuOpen, setIsColumnMenuOpen] = useState(false);
  const [draggedColumnId, setDraggedColumnId] = useState(null);
  const didMountReloadEffect = useRef(false);

  const defaultColumns = props.headRows.flatMap((row) =>
    Array.isArray(row) ? row : [row]
  );
  const [columnPreferences, setColumnPreferences] = useState(() =>
    defaultColumns.map((column) => ({
      id: column.column,
      visible: column.hideable === false ? true : column.visible !== false,
    }))
  );

  const reconcileColumnPreferences = useCallback(
    (savedColumns) => {
      const defaults = props.headRows.flatMap((row) =>
        Array.isArray(row) ? row : [row]
      );
      const byId = new Map(defaults.map((column) => [column.column, column]));
      const reconciled = [];

      (Array.isArray(savedColumns) ? savedColumns : []).forEach((saved) => {
        const column = byId.get(saved.id);
        if (!column) return;
        reconciled.push({
          id: saved.id,
          visible: column.hideable === false ? true : saved.visible !== false,
        });
        byId.delete(saved.id);
      });

      byId.forEach((column) =>
        reconciled.push({
          id: column.column,
          visible: column.hideable === false ? true : column.visible !== false,
        })
      );
      return reconciled;
    },
    [props.headRows]
  );

  useEffect(() => {
    if (!props.columnPreferencesKey) return;
    let active = true;
    const cacheKey = `table-preferences:${
      props.columnPreferencesUserId || "current"
    }:${props.columnPreferencesKey}`;
    const cached = localStorage.getItem(cacheKey);
    if (cached) {
      try {
        setColumnPreferences(reconcileColumnPreferences(JSON.parse(cached)));
      } catch (error) {
        localStorage.removeItem(cacheKey);
      }
    }

    api
      .makeHttpRequest({
        method: "GET",
        url: `/user/table-preferences/${props.columnPreferencesKey}`,
      })
      .then((response) => {
        if (active) {
          setColumnPreferences(reconcileColumnPreferences(response?.columns));
        }
      })
      .catch((error) => {
        if (error?.response?.status !== 404) {
          console.error("TABLE_PREFERENCES_LOAD_ERROR", error);
        }
      });

    return () => {
      active = false;
    };
  }, [
    props.columnPreferencesKey,
    props.columnPreferencesUserId,
    reconcileColumnPreferences,
  ]);

  const saveColumnPreferences = useCallback(
    async (nextPreferences) => {
      setColumnPreferences(nextPreferences);
      if (!props.columnPreferencesKey) return;
      const cacheKey = `table-preferences:${
        props.columnPreferencesUserId || "current"
      }:${props.columnPreferencesKey}`;
      localStorage.setItem(cacheKey, JSON.stringify(nextPreferences));
      try {
        await api.makeHttpRequest({
          method: "PUT",
          url: `/user/table-preferences/${props.columnPreferencesKey}`,
          data: { columns: nextPreferences },
        });
      } catch (error) {
        console.error("TABLE_PREFERENCES_SAVE_ERROR", error);
        if (error?.response?.status !== 404) {
          Swal.fire(
            "Erro!",
            "Não foi possível sincronizar a organização da tabela.",
            "error"
          );
        }
      }
    },
    [props.columnPreferencesKey, props.columnPreferencesUserId]
  );

  const orderedColumns = columnPreferences
    .map((preference) => ({
      preference,
      column: defaultColumns.find((column) => column.column === preference.id),
    }))
    .filter(({ column, preference }) => column && preference.visible);

  const visibleHeadRows = props.columnPreferencesKey
    ? orderedColumns.map(({ column }) => column)
    : props.headRows;

  const [personStatus] = useState([]);

  const sortableColumns = props.headRows.flatMap((row) =>
    Array.isArray(row) ? row : [row]
  );
  const emailColumnIndexes = sortableColumns.reduce((indexes, column, index) => {
    const identifier = `${column.column || ""} ${column.label || ""}`.toLowerCase();
    if (identifier.includes("email") || identifier.includes("e-mail")) {
      indexes.push(index);
    }
    return indexes;
  }, []);

  const formatDataRow = (row) => {
    const formattedRow = props.formatRow(row);
    if (!React.isValidElement(formattedRow)) return formattedRow;

    const originalCells = React.Children.toArray(formattedRow.props.children);
    const displayedCells = props.columnPreferencesKey
      ? orderedColumns.map(({ column }) => {
          const originalIndex = defaultColumns.findIndex(
            (item) => item.column === column.column
          );
          return originalCells[originalIndex];
        })
      : originalCells;
    const cells = React.Children.map(displayedCells, (cell, index) => {
      if (!React.isValidElement(cell)) return cell;
      return React.cloneElement(cell, {
        style: {
          ...(cell.props.style || {}),
          textTransform: emailColumnIndexes.includes(index)
            ? "lowercase"
            : "uppercase",
        },
      });
    });

    return React.cloneElement(formattedRow, undefined, cells);
  };

  const moveColumn = (targetColumnId) => {
    if (!draggedColumnId || draggedColumnId === targetColumnId) return;
    const next = [...columnPreferences];
    const from = next.findIndex((column) => column.id === draggedColumnId);
    const to = next.findIndex((column) => column.id === targetColumnId);
    if (from < 0 || to < 0) return;
    const [moved] = next.splice(from, 1);
    next.splice(to, 0, moved);
    setDraggedColumnId(null);
    saveColumnPreferences(next);
  };

  const toggleColumn = (columnId) => {
    const next = columnPreferences.map((column) =>
      column.id === columnId ? { ...column, visible: !column.visible } : column
    );
    saveColumnPreferences(next);
  };

  const resetColumns = async () => {
    const defaults = reconcileColumnPreferences([]);
    setColumnPreferences(defaults);
    const cacheKey = `table-preferences:${
      props.columnPreferencesUserId || "current"
    }:${props.columnPreferencesKey}`;
    localStorage.removeItem(cacheKey);
    try {
      await api.makeHttpRequest({
        method: "DELETE",
        url: `/user/table-preferences/${props.columnPreferencesKey}`,
      });
    } catch (error) {
      console.error("TABLE_PREFERENCES_RESET_ERROR", error);
    }
  };

  const handleSort = (column) => {
    if (column.sortable === false) return;
    const nextOrderBy = column.sortField || column.column;
    setPage(0);
    setOrder((currentOrder) =>
      orderBy === nextOrderBy && currentOrder === "asc" ? "desc" : "asc"
    );
    setOrderBy(nextOrderBy);
  };

  function searchLoad(e) {
    loadRecords({
      page: 0,
      search: e,
    });
  }

  const onSearch = useRef(
    debounce((e, searchLoad) => {
      searchLoad(e);
    }, 500)
  ).current;

  function search(e, select) {
    props.localSearch || select
      ? onSearch(e.target.value, (e) => props.localFilter(select, e, setCount))
      : onSearch(e.target.value, (e) => searchLoad(e));
  }

  const showMap = () => setIsOpen(!isOpen);

  async function exportRecords(config = {}) {
    setIsLoadingExport(true);

    let params = {
      page: (config.page !== undefined ? config.page : page) + 1,
      perPage: config.perPage || rowsPerPage,
      search: config.search,
      where: config.status ? config.status.join(", ") : "",
    };

    await api.download(
      {
        url: config.isEndpointFull
          ? config.endpoint || ""
          : props.endpoint + (config.endpoint || ""),
        params,
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    );

    setIsLoadingExport(false);
  }

  const loadRecords = useCallback(
    async (config = {}) => {
      setIsLoading(true);

      let params = props.contractInputFilter
        ? {
            page: (config.page !== undefined ? config.page : page) + 1,
            perPage: config.perPage || rowsPerPage,
            orderBy: config.orderBy || orderBy,
            orderByDirection: config.orderByDirection || order,
            search: config.search,
          }
        : {
            page: (config.page !== undefined ? config.page : page) + 1,
            perPage: config.perPage || rowsPerPage,
            search: config.search,
            where: config.personStatus || personStatus,
            optionFilter: optionFilter,
            orderBy: config.orderBy || orderBy,
            orderByDirection: config.orderByDirection || order,
          };
      try {
        let response = {};

        response = await api.makeHttpRequest({
          url: props.endpoint,
          params,
        });

        const { rows, meta } = normalizePaginatedResponse(response, params);

        setRows(sortRows(rows, orderBy, order));
        setCount(meta.total);

        setPage(
          params.page < meta.lastPage
            ? meta.currentPage - 1 > 0
              ? meta.currentPage - 1
              : 0
            : meta.lastPage - 1 > 0
            ? meta.lastPage - 1
            : 0
        );
      } catch (e) {
        console.error("DATATABLE_LOAD_ERROR", {
          endpoint: props.endpoint,
          message: e?.message,
          status: e?.response?.status,
          payload: e?.response?.data,
        });
        Swal.fire(
          "Erro!",
          `Não foi possível carregar os dados de ${props.endpoint}. ${
            e?.response?.status ? `Status: ${e.response.status}.` : ""
          }`,
          "error"
        );
      } finally {
        setIsLoading(false);
        setReload(false);
      }
    },
    [
      optionFilter,
      order,
      orderBy,
      page,
      personStatus,
      props.contractInputFilter,
      props.endpoint,
      rowsPerPage,
    ]
  );

  const handleChangeFilterSelect = useCallback(
    (event) => {
      const newValue = event.target.value;
      setPage(0);
      setOptionFilter(newValue || "");
    },
    []
  );

  useEffect(() => {
    if (!didMountReloadEffect.current) {
      didMountReloadEffect.current = true;
      return;
    }
    if (!props.cancelReload) {
      loadRecords({
        page:
          props.skipPaginationState === false ? pageCurrentState || page : page,
        search: props.search || inputSearch,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload, props.reload]);

  useEffect(() => {
    if (Boolean(props.dateRange)) {
      loadRecords({
        page:
          props.skipPaginationState === false ? pageCurrentState || page : page,
        search: props.search || inputSearch,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dateRange]);

  useEffect(() => {
    loadRecords({
      search: inputSearch,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadRecords, personStatus]);

  function loadPaginationState() {
    const paginationState = JSON.parse(
      localStorage.getItem("pagination") || "{}"
    );
    if (paginationState[props.endpoint]) {
      return paginationState[props.endpoint];
    }

    return {};
  }

  function handleChangePage(_, newPage) {
    setPage(newPage);
    loadRecords({ page: newPage, search: inputSearch });
  }

  function handleChangeRowsPerPage(event) {
    setPage(0);
    setRowsPerPage(+event.target.value);
    loadRecords({
      perPage: event.target.value,
      page: 0,
      search: inputSearch,
    });
  }

  function refreshAction() {
    loadRecords({
      page: pageCurrentState || page,
      search: inputSearch,
    });
  }

  if (reload) {
    refreshAction();
  }

  const generateMobileButtons = () => {
    return (
      <>
        {!props.hiddenReload && (
          <li className="kt-nav__item">
            <a href={void 0} className="kt-nav__link" onClick={refreshAction}>
              <i className="kt-nav__link-icon flaticon2-reload"></i>
              <span className="kt-nav__link-text">Atualizar</span>
            </a>
          </li>
        )}
        {props.buttons.length > 0
          ? props.buttons.map((btn, i) => {
              const btnOnClick = btn.endpoint
                ? () =>
                    exportRecords({
                      orderByDirection: order,
                      orderBy: orderBy,
                      search: inputSearch,
                      endpoint: btn.endpoint,
                      isEndpointFull: btn.isEndpointFull,
                    })
                : btn.onClick;

              return btn.path ? (
                <Link to={btn.path} className="kt-nav__item" key={i}>
                  <span className="kt-nav__link" onClick={btnOnClick}>
                    <i
                      className={`kt-nav__link-icon flaticon-${btn.icone}`}
                    ></i>
                    <span className="kt-nav__link-text">{btn.label}</span>
                  </span>
                </Link>
              ) : (
                <li className="kt-nav__item" key={i}>
                  <a
                    href={void 0}
                    className="kt-nav__link"
                    onClick={btnOnClick}
                  >
                    <i
                      className={`kt-nav__link-icon flaticon-${btn.icone}`}
                    ></i>
                    <span className="kt-nav__link-text">{btn.label}</span>
                  </a>
                </li>
              );
            })
          : null}
      </>
    );
  };

  return (
    <div
      className={`xv-datatable col-xl-12 ${props.className}`}
      style={{
        minHeight: "max-content",
        marginTop: "0px",
        padding: props.addButtonOpenDiv ? "0 0 0 0" : "0",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <StyledTableContent
        className="xv-datatable__surface"
        style={{
          maxHeight: "fit-content",
          backgroundColor: globalColors.backgroundColor5,
          boxShadow: props.removeTableShadow
            ? "none"
            : "0px 0px 10px 0px rgba(0,0,0,0.2)",
          padding: props.removePadding ? 0 : 16,
        }}
      >
        <Loading isLoading={isLoading || isLoadingExport} />
        <Portlet
          className="xv-datatable__portlet"
          fluidHeight={true}
          style={{
            backgroundColor: "transparent",
            boxShadow: "none",
            padding: 0,
            marginLeft: "8px",
            marginRight: "0px",
          }}
        >
          <div
            style={{
              padding: 0,
              margin: 0,
              height: props.hideTitle && !props.addButtonUrl ? 0 : "52px",
              marginTop: "5px",
            }}
          >
            {props.title && props.icon && (!props.hideTitle || props.addButtonUrl) ? (
              <AdminTitle
                icon={props.icon}
                title={props.title}
                disableHeader={props.disableHeader}
                width={props.width}
                mobile={props.mobile}
                backgroundColor={props?.backgroundColor}
                actions={props.actions}
                refreshAction={props.refreshAction}
                generateMobileButtons={generateMobileButtons}
                addButtonUrl={props.addButtonUrl}
                tooltip={props.tooltip}
                titleButon={props.titleButon}
                colorButton={props?.colorButton}
                removeMargin={props.removeTitleMargin}
                hideTitle={props.hideTitle}
              />
            ) : null}
          </div>

          {props.addSelect && props.addSelect}

          <PortletBody
            fit={true}
            fluid={true}
            style={{
              padding: 0,
            }}
          >
            <div className={`${classes.root} xv-datatable__root`}>
              {props.formView ? props.formView : null}

              {props.placeholderSearch ? (
                <div
                  className={`${classes.search} xv-datatable__search`}
                  style={{
                    border: "0.5 px solid red",
                  }}
                >
                  <Form.Row
                    className={`${classes.rows} xv-inline-filter-row xv-datatable__filter-row`}
                    style={{
                      padding: "0 !important",
                      margin: 0,
                      backgroundColor: "transparent",
                    }}
                  >
                    <Grid container className="xv-datatable__filter-grid">
                      <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                        <Form.Group
                          style={{
                            display: "flex",
                            alignItems: "center",
                            position: "relative",
                          }}
                        >
                          <SvgIcon
                            component={SearchIcon}
                            viewBox="0 0 20 20"
                            stroke={globalColors.primaryColor5}
                            style={{
                              fontSize: "20px",
                              color: globalColors.primaryColor5,
                              position: "absolute",
                              left: "20px",
                              fill: "none",
                            }}
                          />
                          <Form.Control
                            type="text"
                            name="search"
                            style={{
                              paddingLeft: "60px",
                            }}
                            size="lg"
                            onChange={(e) => {
                              search(e);
                              setInputSearch(e.target.value);
                            }}
                            value={inputSearch}
                            className={`${classes.input}`}
                            placeholder={props.placeholderSearch}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <SvgIcon
                                    component={SearchIcon}
                                    viewBox="0 0 20 20"
                                    stroke={globalColors.primaryColor5}
                                    style={{
                                      fontSize: "20px",
                                      color: globalColors.primaryColor5,
                                      fill: "none",
                                    }}
                                  />
                                </InputAdornment>
                              ),
                            }}
                          />
                        </Form.Group>
                      </Grid>

                      {props.selectInput ? (
                        <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
                          <InputForm
                            name="role"
                            label={props.selectInput.label}
                            placeholder={props.selectInput.title}
                            isSelect
                            isClearable
                            options={props.selectInput.options}
                            value={
                              props.selectInput.options.find(
                                (item) => item.value === optionFilter
                              ) || null
                            }
                            onChange={(option) =>
                              handleChangeFilterSelect({
                                target: { value: option?.value || "" },
                              })
                            }
                          />
                        </Grid>
                      ) : null}
                    </Grid>
                  </Form.Row>

                  {props.width >= 768 || !props.mobile ? (
                    props.buttons && props.buttons.length > 0 ? (
                      <>
                        {props.buttons.map((item, index) => (
                          <div className={classes.addBtn} key={index}>
                            <HeaderButton
                              path={item.path}
                              label={item.label}
                              onClick={
                                item.endpoint
                                  ? () =>
                                      exportRecords({
                                        orderByDirection: order,
                                        orderBy: orderBy,
                                        search: inputSearch,
                                        endpoint: item.endpoint,
                                        isEndpointFull: item.isEndpointFull,
                                      })
                                  : item.onClick
                              }
                              icone={item.icone}
                              disabled={item.disabled}
                            />
                          </div>
                        ))}
                        {!props.hiddenReload && (
                          <RefreshButton refreshAction={refreshAction} />
                        )}
                      </>
                    ) : null
                  ) : null}
                </div>
              ) : null}

              {props.columnPreferencesKey ? (
                <div className="xv-column-customizer">
                  <button
                    type="button"
                    className="xv-column-customizer__trigger"
                    onClick={() => setIsColumnMenuOpen((open) => !open)}
                    aria-expanded={isColumnMenuOpen}
                  >
                    <MdViewColumn aria-hidden="true" />
                    Personalizar tabela
                  </button>
                  {isColumnMenuOpen ? (
                    <div className="xv-column-customizer__menu">
                      <div className="xv-column-customizer__heading">
                        <strong>Organizar colunas</strong>
                        <span>Arraste para ordenar e desmarque para ocultar.</span>
                      </div>
                      <div className="xv-column-customizer__list">
                        {columnPreferences.map((preference) => {
                          const column = defaultColumns.find(
                            (item) => item.column === preference.id
                          );
                          if (!column) return null;
                          return (
                            <div
                              key={preference.id}
                              className="xv-column-customizer__item"
                              draggable
                              onDragStart={() => setDraggedColumnId(preference.id)}
                              onDragOver={(event) => event.preventDefault()}
                              onDrop={() => moveColumn(preference.id)}
                            >
                              <MdDragIndicator aria-hidden="true" />
                              <label>
                                <input
                                  type="checkbox"
                                  checked={preference.visible}
                                  disabled={column.hideable === false}
                                  onChange={() => toggleColumn(preference.id)}
                                />
                                <span>{column.label}</span>
                              </label>
                            </div>
                          );
                        })}
                      </div>
                      <button
                        type="button"
                        className="xv-column-customizer__reset"
                        onClick={resetColumns}
                      >
                        Restaurar padrão
                      </button>
                    </div>
                  ) : null}
                </div>
              ) : null}

              <div className={`${classes.tableContainer} xv-datatable__table-container`}>
                <Paper className={`${classes.paper} xv-datatable__paper`}>
                  <div className={`${classes.tableWrapper} xv-datatable__table-wrapper`}>
                    <Table
                      className={`${classes.table} xv-datatable__table`}
                      style={{
                        borderRadius: "4px 4px 0px 0px",
                      }}
                    >
                      <EnhancedTableHead
                        rowCount={rows?.length}
                        headRows={visibleHeadRows}
                        styledTableCell={props.styledTableCell}
                        onSort={handleSort}
                        order={order}
                        orderBy={orderBy}
                      />
                      <TableBody
                        style={{
                          height: "32px",
                        }}
                      >
                        {isLoading ? (
                          <TableRow component={StyledTableRow}>
                            <TableCell
                              colSpan={visibleHeadRows?.length}
                              className="text-center"
                              component={StyledTableCell}
                            >
                              Aguarde...
                            </TableCell>
                          </TableRow>
                        ) : count > 0 ? (
                          rows.map((row) => formatDataRow(row))
                        ) : (
                          <TableRow component={StyledTableRow}>
                            <TableCell
                              colSpan={visibleHeadRows.length}
                              className="text-center"
                              component={StyledTableCell}
                            >
                              Nenhum registro encontrado.
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </div>
                </Paper>
              </div>
              <Table className="xv-datatable__pagination">
                <TableFooter
                  style={{
                    margin: 0,
                  }}
                >
                  <TableRow>
                    <TablePagination
                      rowsPerPageOptions={[]}
                      colSpan={10}
                      count={count ? count : 0}
                      rowsPerPage={rowsPerPage}
                      style={{
                        color: globalColors.backgroundColor2,
                        fontWeight: "400",
                        padding: "0 10px",
                        margin: 0,
                      }}
                      page={page ? page : 0}
                      id="MuiTable-root-custom"
                      labelRowsPerPage=""
                      labelDisplayedRows={({ from, to, count }) =>
                        `${from}-${to} de ${count}`
                      }
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      ActionsComponent={(props) => (
                        <Container
                          maxWidth="sm"
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            right: "-10px",
                            fontSize: "17px",
                            color: globalColors.backgroundColor2,
                            fontWeight: "bold",
                            padding: 0,
                            margin: 0,
                            marginLeft: "25px",
                            width: "120px",
                          }}
                        >
                          <IconButton
                            onClick={() => props.onChangePage({}, 0)}
                            disabled={props.page === 0}
                            aria-label="Primeira Página"
                            style={{
                              width: "10px",
                            }}
                            sx={{
                              "&:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <SvgIcon
                              component={FirstPageIcon}
                              style={{
                                fontSize: "17px",
                                color:
                                  props.page === 0
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              props.onChangePage({}, props.page - 1)
                            }
                            disabled={props.page === 0}
                            aria-label="Anterior"
                            style={{
                              width: "10px",
                            }}
                          >
                            <SvgIcon
                              component={PreviousPageIcon}
                              style={{
                                fontSize: "17px",
                                color:
                                  props.page === 0
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              props.onChangePage({}, props.page + 1)
                            }
                            disabled={
                              props.page >=
                              Math.ceil(props.count / props.rowsPerPage) - 1
                            }
                            aria-label="Próxima"
                            style={{
                              width: "10px",
                            }}
                          >
                            <SvgIcon
                              component={NextPageIcon}
                              style={{
                                fontSize: "17px",
                                color:
                                  props.page >=
                                  Math.ceil(props.count / props.rowsPerPage) - 1
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              props.onChangePage(
                                {},
                                Math.max(
                                  0,
                                  Math.ceil(props.count / props.rowsPerPage) - 1
                                )
                              )
                            }
                            disabled={
                              props.page >=
                              Math.ceil(props.count / props.rowsPerPage) - 1
                            }
                            aria-label="Última Página"
                            style={{
                              width: "20px",
                              padding: 0,
                              margin: 0,
                            }}
                            sx={{
                              "&:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <SvgIcon
                              component={LastPageIcon}
                              style={{
                                fontSize: "17px",
                                padding: 0,
                                margin: 0,
                                color:
                                  props.page >=
                                  Math.ceil(props.count / props.rowsPerPage) - 1
                                    ? "#ccc"
                                    : globalColors.backgroundColor2,
                                fill: "none",
                              }}
                            />
                          </IconButton>
                        </Container>
                      )}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </div>
          </PortletBody>
        </Portlet>
      </StyledTableContent>

      {props.addButtonOpenDiv ? (
        <ImageContainer showMap={isOpen}>
          <OpenContainerButton onClick={showMap}>
            {isOpen ? (
              <MdKeyboardArrowLeft className="arrow" />
            ) : (
              <MdKeyboardArrowRight className="arrow" />
            )}
          </OpenContainerButton>

          <img src={ImagemDefault} alt="Mapa do cemitério" />
        </ImageContainer>
      ) : null}
    </div>
  );
};

export default Datatable;
